var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { promoCodeActivate as promoCodeActivateAction } from "../../actions/promoCode/creators/promocodeAction";
import { getFreebet as getFreebetAction } from "../../actions/auth/creators/SignIn";
import { siteType } from "../../constants/configMap";
var messages = defineMessages({
    enter_promocode: {
        id: "join.fast.type.promocode",
        defaultMessage: "Введите промо-код"
    },
    apply_promocode: {
        id: "join.fast.type.promocode.apply",
        defaultMessage: "Применить"
    },
    "-1": {
        id: "promocode.error.not_found",
        defaultMessage: "Промокод не найден"
    },
    "-2": {
        id: "promocode.error.not_active",
        defaultMessage: "Промокод не активен"
    },
    "-3": {
        id: "promocode.error.used",
        defaultMessage: "Промокод уже использован"
    },
    "-4": {
        id: "promocode.error.not_available",
        defaultMessage: "Промокод недоступен"
    },
    '-5': {
        id: "promocode.error.default",
        defaultMessage: "Промокод не активирован, попробуйте позже"
    },
    '-6': {
        id: "promocode.error.identification_required",
        defaultMessage: "Для использования данного промокода необходимо подтвердить свою личность. Просьба обратиться в онлайн чат службы поддержки."
    },
    '-7': {
        id: "promocode.error.expired",
        defaultMessage: "Промокод просрочен и не может быть активирован"
    },
    '-11': {
        id: "promocode.error.cannot_activate",
        defaultMessage: "Активация промокода невозможна"
    },
    default: {
        id: "promocode.error.default",
        defaultMessage: "Промокод не активирован, попробуйте позже"
    },
    "Promocode not found": {
        id: "promocode.error.not_found",
        defaultMessage: "Промокод не найден"
    },
    "Promocode has already been used": {
        id: "promocode.error.used",
        defaultMessage: "Промокод уже использован"
    },
    "success": {
        id: "promocode.success",
        defaultMessage: "Промокод успешно активирован"
    }
});
var PromoCodeApply = /** @class */ (function (_super) {
    __extends(PromoCodeApply, _super);
    function PromoCodeApply(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            _this.setState({ PromocodeText: e.target.value });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.promoCodeActivateAction({
                GamblerId: _this.props.user.gamblerId,
                PromocodeText: _this.state.PromocodeText,
                SiteType: siteType
            });
        };
        _this.state = {
            PromocodeText: ""
        };
        return _this;
    }
    PromoCodeApply.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.promoCodeSuccess && !prevProps.promoCodeSuccess) {
            this.props.getFreebetAction();
        }
    };
    PromoCodeApply.prototype.render = function () {
        return (_jsxs("form", __assign({ style: { maxWidth: 500, gap: 5 }, onSubmit: this.handleSubmit }, { children: [_jsx("div", __assign({ className: "input mb-1" }, { children: _jsx("input", { className: "text-center", type: "text", name: "PromocodeText", value: this.props.value, onChange: this.handleChange, placeholder: this.props.intl.formatMessage(messages.enter_promocode) }) })), !!this.props.promoCodeError ? (_jsx("div", __assign({ className: "text-danger text-center", style: { color: 'red', marginBottom: 10 } }, { children: this.props.intl.formatMessage(messages[this.props.promoCodeError] || messages.default) }))) : null, !!this.props.promoCodeSuccess ? (_jsx("div", __assign({ className: "text-success text-center" }, { children: this.props.intl.formatMessage(messages.success) }))) : null, _jsx("div", __assign({ className: "controls" }, { children: _jsx("button", __assign({ type: "submit", className: "button", onClick: this.props.applyPromoCode, disabled: !this.state.PromocodeText }, { children: this.props.intl.formatMessage(messages.apply_promocode) })) }))] })));
    };
    return PromoCodeApply;
}(Component));
PromoCodeApply.propTypes = {
    intl: PropTypes.object.isRequired,
    gamblerId: PropTypes.number.isRequired,
    promoCodeActivate: PropTypes.func.isRequired,
    promoCodeError: PropTypes.number,
    promoCodeSuccess: PropTypes.bool,
    getFreebetAction: PropTypes.func.isRequired
};
function mapStateToProps(state) {
    var user = state.auth.user;
    var promoCodeError = state.promoCode.error;
    var promoCodeSuccess = state.promoCode.success;
    return {
        user: user,
        promoCodeError: promoCodeError,
        promoCodeSuccess: promoCodeSuccess
    };
}
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        promoCodeActivateAction: promoCodeActivateAction,
        getFreebetAction: getFreebetAction
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PromoCodeApply));



// WEBPACK FOOTER //
// ./src/components/promoCode/PromoCodeApply.jsx